<template>
<div>
    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top py-3" id="mainNav">
        <div class="container">
            <div class="navbar-brand js-scroll-trigger" style="margin-right: 0;">
                <img class="icon-size-case-1" v-lazy="logoLQWhiteObj"/>
                <div v-lazy:background-image="logoLQWhiteObj"></div>
            </div>
            <div class="navbar-tagline text-white font-weight-bold font-custom" v-t="{path: 'mainSectionText1'}"></div>
            <LanguageSelector />
        </div>
    </nav>

    <!-- Main Section or Masthead -->
    <header class="masthead custom-masthead">
        <div class="video-background">
            <div class="video-foreground">
                <!-- <youtube :video-id="videoId" ref="youtube" :player-vars="playerVars" @playing="playing" @paused="playVideo()"></youtube> -->
                <!-- Loading overlay -->
                <transition name="fade-fast">
                  <div v-if="isVideoLoading" class="video-loading-overlay">
                    <div class="spinner"></div>
                  </div>
                </transition>
                <video id="video-intro" loop autoplay muted playsinline class="video-fit">
                    <source :src="videoSource" type="video/mp4">
                </video>
            </div>
        </div>
        <div class="container h-100 fixing-center-1 padding-addition">
          <!-- Removed the tagline from here -->
          <div class="col-sm-8 offset-sm-2 col-8-custom offset-2-custom text-center no-padding-left">            
          </div>                    
            <div class="row h-100 align-items-center justify-content-center text-center">
                <!-- <div class="col-lg-10 text-left">
                    <h1 class="text-white font-weight-bold">
                      The best tech solutions <br/> for learning the Quran <br/>Insha Allah!
                      <br/><br/>
                    </h1>
                </div>         -->
            </div>
        </div>
    </header>    
    
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';
import i18n from '@/plugins/i18n';

import LanguageSelector from './LanguageSelector.vue';
import ProductContentLQTajwid from './ProductContentLQTajwid.vue';
import LogoLQWhite from '@/assets/logos/logo_lq_white_min_v2024.png';

export default {
   name: 'MainSection' ,
   components: {
    LanguageSelector,
     ProductContentLQTajwid
   },
   data() {
    return {
      logoLQWhiteObj: createImageObject(LogoLQWhite),
      isLandscape: window.innerWidth > window.innerHeight,
      isMobileDevice: false,
      backgroundVideoSources: {
        landscape: {
          EN: 'https://bucket.learn-quran.co/media/videolq-landscape.2fb3d4e2.mp4',
          ID: 'https://bucket.learn-quran.co/media/videolq-landscape-id.26210c7a.mp4',
          AR: 'https://bucket.learn-quran.co/media/videolq-landscape-ar.576c3f9f.mp4',
        },
        landscapeMobile: {
          EN: 'https://bucket.learn-quran.co/media/videolq-landscape-mobile.a75aaea2.mp4',
          ID: 'https://bucket.learn-quran.co/media/videolq-landscape-mobile-id.53732520.mp4',
          AR: 'https://bucket.learn-quran.co/media/videolq-landscape-mobile-ar.27830496.mp4',
        },
        portrait: {
          EN: 'https://bucket.learn-quran.co/media/videolq-portrait.1f2994d3.mp4',
          ID: 'https://bucket.learn-quran.co/media/videolq-portrait-id.62200077.mp4',
          AR: 'https://bucket.learn-quran.co/media/videolq-portrait-ar.66925321.mp4',
        },
      },
      isSamsungBrowser: false,
  // Loading state for video spinner
  isVideoLoading: true,
      // videoId: 'itxNQtHwFUU',      
      // playerVars: {
      //   controls: 0,
      //   mute: 1,
      //   loop: 1,
      //   playlist: 'itxNQtHwFUU',
      //   showinfo: 0,
      //   rel: 0,
      //   autoplay: 1
      // },
      // for button tab product
    }
  },
  mounted() {
    // alert(window.innerHeight);

    this.isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
    // Force class on body so CSS can act globally
    if (this.isSamsungBrowser) {
      document.body.classList.add('force-dark');
    }
    // this.playVideo();
    this.$nextTick(() => {
      // alert('main section finish loaded')
      this.$emit('isImpactSection', 'impactSectionActive')

      // Check if user is on a mobile device
      this.detectMobileDevice();

      window.addEventListener('resize', this.changeHeightMasthead);
      window.addEventListener('resize', this.handleVideoResize);
      window.addEventListener('orientationchange', this.handleVideoResize);

      // Add specific handler for orientation change on mobile
      window.addEventListener('orientationchange', () => {
        // Update orientation after a short delay to allow device to complete rotation
        setTimeout(() => {
          this.isLandscape = window.innerWidth > window.innerHeight;
          this.detectMobileDevice();
          console.log('Orientation changed event. Now in', this.isLandscape ? 'landscape' : 'portrait', 'mode');
          console.log('Video source after orientation change:', this.videoSource);
        }, 100);
      });

      // Initialize the video
      this.initVideo();

      //Init
      this.changeHeightMasthead()
    });
  },
   computed: {
    videoSource() {
        // If it's a mobile device in landscape mode, use the mobile landscape video
        if (this.isMobileDevice && this.isLandscape) {
          console.log('Video used: Mobile Landscape ' + i18n.locale);
          return this.safeUrl(this.backgroundVideoSources.landscapeMobile[i18n.locale]);
        }

        // Otherwise use the videos based on orientation
        const source = this.isLandscape
          ? this.backgroundVideoSources.landscape[i18n.locale]
          : this.backgroundVideoSources.portrait[i18n.locale];
        console.log(`Video used: ${this.isLandscape ? 'Landscape' : 'Portrait'} ${i18n.locale}`);
        return this.safeUrl(source);
    }
  },
  watch: {
    // Watch for changes in the video source and reload video when necessary
    videoSource() {
      // Start showing loader immediately on source change
      this.showVideoLoading();
      this.$nextTick(() => {
        const video = document.getElementById('video-intro');
        if (video) {
          const wasPlaying = !video.paused;
          video.load();
          if (wasPlaying) {
            video.play().catch(e => console.log('Could not autoplay after source change:', e));
          }
        }
      });
    }
  },   
  methods: {
    playVideo() {
      // this.player.playVideo()
    },
    initVideo() {
      // First, check if we're in landscape or portrait mode
      this.isLandscape = window.innerWidth > window.innerHeight;
      
      // Re-check device type to ensure proper video selection
      this.detectMobileDevice();
      
      const video = document.getElementById('video-intro');
      if (video) {
        console.log('Initializing video with source:', this.videoSource);
        // Show loading when we start initializing
        this.showVideoLoading();

        // Attach video load lifecycle listeners
        const onLoadStart = () => this.showVideoLoading();
        const onWaiting = () => this.showVideoLoading();
        const onStalled = () => this.showVideoLoading();
        const onLoadedData = () => this.hideVideoLoadingSoon();
        const onCanPlay = () => this.hideVideoLoadingSoon();
        const onCanPlayThrough = () => this.hideVideoLoadingSoon();
        const onPlaying = () => this.hideVideoLoadingSoon();
        const onError = () => this.hideVideoLoadingSoon();

        // Register listeners once
        video.addEventListener('loadstart', onLoadStart);
        video.addEventListener('waiting', onWaiting);
        video.addEventListener('stalled', onStalled);
        video.addEventListener('loadeddata', onLoadedData);
        video.addEventListener('canplay', onCanPlay);
        video.addEventListener('canplaythrough', onCanPlayThrough);
        video.addEventListener('playing', onPlaying);
        video.addEventListener('error', onError);
        
        video.load();
        // Try to play the video
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Auto-play was prevented:', error);
            // We need user interaction to play the video
            document.addEventListener('click', () => {
              video.play();
            }, { once: true });
          });
        }
        
        this.handleVideoResize();
      }
    },
    handleVideoResize() {
      // Update landscape orientation flag
      const previousOrientation = this.isLandscape;
      this.isLandscape = window.innerWidth > window.innerHeight;
      
      // If orientation changed, update device detection
      if (previousOrientation !== this.isLandscape) {
        this.detectMobileDevice();
        console.log('Orientation changed. Now in', this.isLandscape ? 'landscape' : 'portrait', 'mode');
        console.log('Video source:', this.videoSource);
      }
      
      const video = document.getElementById('video-intro');
      if (video) {
        // Reset inline styles
        video.style.width = 'auto';
        video.style.height = 'auto';
        video.style.maxWidth = '100%';
        video.style.maxHeight = '100%';
        
        // Calculate optimal width based on aspect ratio
        const videoRatio = video.videoWidth / video.videoHeight;
        const windowRatio = window.innerWidth / window.innerHeight;
        
        // If video is wider than it is tall (landscape)
        if (videoRatio > windowRatio) {
          // Video is wider than the viewport, constrain by height
          video.style.height = '100%';
          video.style.width = 'auto';
        } else {
          // Video is taller than the viewport, constrain by width
          video.style.width = '100%';
          video.style.height = 'auto';
        }
      }
    },
    changeHeightMasthead() {
      document.getElementsByClassName('masthead')[0].style = "height:"+window.innerHeight+"px";
    },
    detectMobileDevice() {
      // This detects actual mobile devices, not just screen size
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Check specifically for mobile browsers
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isAndroid = /Android/.test(userAgent);
      
      // More comprehensive check for mobile devices
      const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      
      // Add extra check for iPhone Chrome which might be detected incorrectly
      const isChromeiOS = /CriOS/.test(userAgent);
      
      // Check for touch capability as an additional signal
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Combine all checks
      this.isMobileDevice = isMobile || isIOS || isAndroid || (isChromeiOS && hasTouch);
      
      // Log the result and user agent for debugging
      console.log('User Agent:', userAgent);
      console.log('Is mobile device:', this.isMobileDevice);
      console.log('Is iOS:', isIOS);
      console.log('Is Android:', isAndroid);
      console.log('Is Chrome iOS:', isChromeiOS);
    },
    playing() {
      console.log('\o/ we are watching!!!')
    },
    safeUrl(url) {
      // Upgrade to https if the page is served via https to avoid mixed content blocks
      try {
        if (window && window.location && window.location.protocol === 'https:' && typeof url === 'string') {
          return url.replace(/^http:\/\//i, 'https://');
        }
      } catch (e) { /* ignore */ }
      return url;
    },
    showVideoLoading() {
      this.isVideoLoading = true;
    },
    hideVideoLoadingSoon() {
      // Small delay so spinner isn't flickery for very fast loads
      clearTimeout(this._hideSpinnerTimer);
      this._hideSpinnerTimer = setTimeout(() => {
        this.isVideoLoading = false;
      }, 120);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changeHeightMasthead);
    window.removeEventListener('resize', this.handleVideoResize);
    window.removeEventListener('orientationchange', this.handleVideoResize);
    // Make sure to remove all event listeners
    window.removeEventListener('orientationchange', () => {});
  }
}
</script>

<style>

/* for video background */
.video-background {
  background: #000; /* Black background */
  position: fixed;
  top: 0; right: 0; bottom: 50px; left: 0; /* Added bottom margin to make room for ProductContentBG */
  width: 100%;
  height: calc(100vh - 50px); /* Reduce height to leave space for the bottom section */
  z-index: -99;
  overflow: hidden;
}
.video-foreground {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* Ensure the foreground is also black */
}
.video-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 20, 20, 0.75); /* dark gray vibe */
  z-index: 2; /* above the video */
  pointer-events: none; /* don't block clicks - video area shouldn't receive clicks anyway */
}
.spinner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: rgba(255, 255, 255, 0.85);
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
/* subtle fade for loader mount/unmount */
.fade-fast-enter-active, .fade-fast-leave-active { transition: opacity 150ms ease; }
.fade-fast-enter, .fade-fast-leave-to { opacity: 0; }
.video-fit {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  width: auto; /* Let the video determine its width based on height */
  height: auto;
  transform: translateX(-50%) translateY(-50%);
  object-fit: contain;
  background-color: transparent; /* Make sure video background is transparent */
  transition: opacity 0.3s ease; /* Add smooth transition when video changes */
}


/* Added styles for navbar tagline */
.navbar-tagline {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.25rem;
  margin-left: -0.5rem;
  flex-grow: 1;
}

@media (max-width: 991.98px) {
  .navbar-tagline {
    font-size: 1rem;
    max-width: 60%;
  }
}

@media (max-width: 767.98px) {
  .navbar-tagline {
    font-size: 0.85rem;
    max-width: 50%;
  }
}

@media (max-width: 575.98px) {
  .navbar-tagline {
    font-size: 0.75rem;
    max-width: 40%;
  }
}

/* navbar */
.lang-choose {
  /* v1 */
  /* color:white!important;font-size: 1.3rem;font-family: 'RobotoBold'; */
  margin-right:1rem;
  color:white!important;
  font-size: 1.3rem;
}
#mainNav {
    background-color: transparent!important;
    box-shadow: 0 0rem 0rem rgba(0, 0, 0)!important;
    position: absolute!important;
}
.dropdown-menu {
  left: unset!important;
  right: 0;
}

/* navbar bottom tab products */
.padding-top-1rem {
  padding-top: 1rem!important;
}
.height-5-rem {
  height: 5rem;
}
.width-8-rem {
  width:8rem;
}
.tab-button-product {
      padding-top: 0;
    padding-bottom: 0;
    height: 3rem;
    padding-right: 0;
    padding-left: 0;
}
.afterclick {
    --afterclick-bg-color: white;
    --afterclick-border-bottom: 5px solid #053448;
    
    color: #fff;
    /* border-bottom: 5px solid #053448!important;     */
    border-bottom: var(--afterclick-border-bottom) !important;
    background-color: var(--afterclick-bg-color) !important;
}
body.dark .afterclick {
  --afterclick-bg-color: #022534;
  --afterclick-border-bottom: 5px solid white!important;
}

body.force-dark .afterclick {
  --afterclick-bg-color: #022534;
  --afterclick-border-bottom: 5px solid white!important;
}

.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
    border-bottom: 5px solid #053448;
    background-color: var(--afterclick-bg-color) !important;
    /* background-color: var(--bg-color) !important; */
}
.collapseProduct {
    position: absolute;
    z-index: 99999999;
}
.card-product {
  z-index: 1;
  border: 0;
}

.img-carousel {
  max-width: 50%;
  height: 100%;
}

.carousel-inner img {
  margin: auto;
}

.desc-product {
  margin-top: auto;
  margin-bottom: auto;
}

/* desktop */
@media (min-width: 992px) {
  .card-product {
      width: 95vw;
    height: 100%;
    min-height: 85vh;
    left: -25%;
    justify-content: center;
    padding: 0;
    padding-bottom: 3%;
    padding-top: 2%;
    border: 0;
  }
}

/* iphone 5 */
@media (max-width: 320px) {
  .card-product {
    /* width: 95vw; */
    height: 100%;
    min-height: 90vh;
    justify-content: center;
    padding: 0;
    padding-bottom: 3%;
    padding-top: 2%;
    border: 0;
    left: -2%;
  }

  .img-carousel {
    max-width:35%;
  }
}

/* galaxy 5 */
@media (max-width: 360px) {
  .img-carousel {
    max-width:35%;
  }
}

/* iphone X */
@media (max-width: 375px) {
  .card-product {
    /* width: 95vw; */
    height: 100%;
    min-height: 90vh;
    justify-content: center;
    padding: 0;
    padding-bottom: 3%;
    padding-top: 2%;
    border: 0;
    left: 0;
  }
}

.btn-warning {
  /* font-family: Raleway-SemiBold;
  font-size: 13px; */
  color: #053448;
  letter-spacing: 1px;
  line-height: 15px;
  border: 2px solid #053448;
  border-radius: 40px;
  background-color: #053448;
  /* background: transparent; */
  transition: all 0.3s ease 0s;
      height: 3rem;
    font-size: 1.2rem;
}

.btn-warning:hover {
  color: #053448!important;
  background: white;
  border: 2px solid #053448;
}

.btn-outline-custom {
  /* font-family: Raleway-SemiBold;
  font-size: 13px; */
  color: #053448;
  letter-spacing: 1px;
  line-height: 15px;
  border: 2px solid #053448;
  border-radius: 40px;
  /* background: transparent; */
  transition: all 0.3s ease 0s;
      height: 3rem;
    /* font-size: 1.2rem; */
}

.btn-outline-custom:hover {
  color: white;
  background: #053448;
  border: 2px solid #053448;
}

.tagline {
  margin-top: 5%;
  margin-bottom: auto!important;
}



/* @media (min-height:320px) {
  .tagline {
    margin-top: -10%;
    margin-bottom: auto!important;
  }
} */
@media only screen and (min-width: 320px) {
  .tagline {
    margin-top: auto;
    margin-bottom: auto!important;
  }
}
@media only screen and (min-height: 667px) {
  .tagline {
    margin-top: 3.5rem;
    margin-bottom: auto!important;
  }
}
@media only screen and (min-height: 736px) {
  .tagline {
    margin-top: 7.5rem;
    margin-bottom: auto!important;
  }
}
@media only screen and (min-height: 812px) {
  .tagline {
    margin-top: 7.5rem;
    margin-bottom: auto!important;
  }
}
@media (min-width: 992px) {
  .tagline {
    margin-top: 5%;
    margin-bottom: auto!important;
  }
}
/* @media (min-height:375px) {
  .tagline {
    margin-top: -5%;
    margin-bottom: auto!important;
  }
}
@media (min-height:414px) {
  .tagline {
    margin-top: -5%;
    margin-bottom: auto!important;
  }

@media (min-width: 992px) {
  .tagline {
    margin-top: 5%;
    margin-bottom: auto!important;
  }
} */

.icon-size-case-1 {
  width:5rem;
  height:100%;
}

.font-size-case-1 {
  font-size: 1.85rem;
  font-family: 'QuattrocentoSansRegular', 'Rubik', sans-serif;
}

@media (width:320px) {
  .font-size-case-1 {
    /* display: block; */
    font-size: larger;
  }
}

@media only screen and (width:568px) {
  .font-size-case-1 {
    font-size: 1.5rem;
  }
}





@media only screen and (min-width: 320px) and (max-width: 568px ) {
  
  .icon-size-case-1 {    
    width: 5rem;
    height: 100%;
  }
  .lang-choose {
    /* v1 */    
    font-size: 0.85rem;
  }
}



@media only screen and (min-height: 320px) and (max-height: 414px) {
  .padding-addition {
    /* padding-bottom: 5rem; */
        padding-bottom: 8rem;
  }
}

@media only screen and (min-width: 320px) and (max-width: 736px ) {
  .padding-addition {
    /* padding-bottom: 5rem; */
        padding-bottom: 8rem;
  }
}

.fixing-center-1 {
    display: flex;
    align-items: center;
}

.custom-masthead {
    padding-top:8rem!important;
}

.no-padding-left {
  padding-left:0;
}

.no-margin-top {
  margin-top:0;
}

.font-custom {
  /* font-family: 'QuattrocentoRegular'!important; */
  font-family: 'QuattrocentoSansRegular', 'Rubik', sans-serif;
  letter-spacing: 0.09rem;
}


@media (width: 320px){
  .col-8-custom {
    max-width: 66.66667%;
  }

  .offset-2-custom {
    margin-left: 16.666667%;
  }
}

@media (width: 568px){
  .col-8-custom {
    max-width: 66.66667%;
  }

  .offset-2-custom {
    margin-left: 16.666667%;
  }
}
</style>
